import { useQuery } from '@tanstack/react-query';
import { ImageOff } from 'lucide-react';
import { useEffect, useMemo } from 'react';
import { api } from '@/lib/api';
import { Skeleton } from '@/components/ui/misc';

/** Media requires the Authorization header, so it is fetched as a blob and shown via an object URL. */
export function MediaImage({ mediaId, alt }: { mediaId: string; alt: string }) {
  const q = useQuery({ queryKey: ['media', mediaId], queryFn: () => api.media.blob(mediaId), staleTime: Infinity, retry: 1 });
  const url = useMemo(() => (q.data ? URL.createObjectURL(q.data) : undefined), [q.data]);
  useEffect(() => () => (url ? URL.revokeObjectURL(url) : undefined), [url]);
  if (q.isLoading) return <Skeleton className="h-48 w-64" />;
  if (!url) return <div className="flex h-24 w-48 items-center justify-center gap-2 rounded-md bg-muted text-xs text-muted-foreground"><ImageOff className="size-4" /> Media unavailable</div>;
  return (
    <a href={url} target="_blank" rel="noreferrer">
      <img src={url} alt={alt} className="max-h-72 max-w-64 rounded-md object-cover" />
    </a>
  );
}
